// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"60c05767","235":"fa51166a","704":"d690981f","985":"b5cb351e"}[chunkId] + ".chunk.css";
};